import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.auth');
import { Component, OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-auth',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.auth/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.auth-layout {
  min-height: 100vh;
  min-height: 100dvh;
  min-height: var(--auth-viewport-height, 100dvh);
  height: 100vh;
  height: 100dvh;
  height: var(--auth-viewport-height, 100dvh);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(16px, 4vh, 40px) 24px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  -webkit-overflow-scrolling: touch;
  scroll-padding: 16px 0;
  background: #f5f5f7;
  box-sizing: border-box;
}
.auth-layout.keyboard-active {
  align-items: flex-start;
  justify-content: center;
  padding: 12px 16px 16px;
}
.auth-layout.keyboard-active .auth-content {
  max-width: 420px;
}
.auth-layout.keyboard-active .auth-logo {
  margin-bottom: 10px;
}
.auth-layout.keyboard-active .auth-logo .logo-inspect,
.auth-layout.keyboard-active .auth-logo .logo-pro {
  font-size: 22px;
  line-height: 1.2;
}
.auth-layout.keyboard-active .auth-card {
  padding: 20px 24px;
  border-radius: 20px;
}

/* ── Animated background blobs ── */
.auth-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.auth-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  will-change: transform;
}
.auth-blob.auth-blob-1 {
  width: 600px;
  height: 600px;
  background: rgba(255, 107, 53, 0.14);
  top: -20%;
  right: -10%;
  animation: blobDrift1 25s ease-in-out infinite;
}
.auth-blob.auth-blob-2 {
  width: 500px;
  height: 500px;
  background: rgba(99, 102, 241, 0.1);
  bottom: -15%;
  left: -8%;
  animation: blobDrift2 30s ease-in-out infinite;
}
.auth-blob.auth-blob-3 {
  width: 400px;
  height: 400px;
  background: rgba(236, 72, 153, 0.07);
  top: 45%;
  left: 55%;
  animation: blobDrift3 22s ease-in-out infinite;
}

@keyframes blobDrift1 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(50px, -60px) scale(1.1);
  }
  66% {
    transform: translate(-30px, 40px) scale(0.95);
  }
}
@keyframes blobDrift2 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(-40px, 50px) scale(1.05);
  }
  66% {
    transform: translate(60px, -30px) scale(0.92);
  }
}
@keyframes blobDrift3 {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(-50px, -40px) scale(1.12);
  }
}
/* ── Content area ── */
.auth-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
}

/* ── Logo ── */
.auth-logo {
  text-align: center;
  margin-bottom: 32px;
  animation: fadeDown 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}
.auth-logo .logo-inspect {
  font-size: 28px;
  font-weight: 800;
  color: #1d1d1f;
  letter-spacing: -0.02em;
}
.auth-logo .logo-pro {
  font-size: 28px;
  font-weight: 800;
  color: #ff6b35;
  letter-spacing: -0.02em;
}

/* ── Card ── */
.auth-card {
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 24px;
  padding: 44px 40px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 8px 40px rgba(0, 0, 0, 0.06);
  animation: fadeUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.1s both;
}
@media (max-width: 480px) {
  .auth-card {
    padding: 32px 24px;
    border-radius: 20px;
  }
}

@media (orientation: landscape) and (max-height: 640px) {
  .auth-layout {
    align-items: flex-start;
    justify-content: center;
    padding: 12px 16px 16px;
  }
  .auth-layout .auth-content {
    max-width: 420px;
  }
  .auth-layout .auth-logo {
    margin-bottom: 10px;
  }
  .auth-layout .auth-logo .logo-inspect,
  .auth-layout .auth-logo .logo-pro {
    font-size: 22px;
    line-height: 1.2;
  }
  .auth-layout .auth-card {
    padding: 20px 24px;
    border-radius: 20px;
  }
}
/* ── Keyframes ── */
@keyframes fadeDown {
  from {
    opacity: 0;
    transform: translateY(-16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`],
})
export class LayoutAuthComponent implements OnInit, OnDestroy {
    public viewportHeightStyle = '100dvh';
    public keyboardActive = false;

    private baseViewportHeight = 0;
    private baseViewportWidth = 0;
    private viewportRaf = 0;
    private readonly keyboardThreshold = 120;
    private readonly removeViewportListeners: Array<() => void> = [];

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    async ngOnInit() {
        await this.service.init(this);
        this.bindViewportListeners();
        this.updateViewportState();
        window.setTimeout(() => this.updateViewportState(), 250);
    }

    public ngOnDestroy() {
        this.removeViewportListeners.forEach(remove => remove());
        this.removeViewportListeners.length = 0;
        if (this.viewportRaf) cancelAnimationFrame(this.viewportRaf);
    }

    private bindViewportListeners() {
        const addListener = (target: EventTarget | null | undefined, eventName: string) => {
            if (!target) return;
            target.addEventListener(eventName, this.scheduleViewportUpdate, { passive: true });
            this.removeViewportListeners.push(() => target.removeEventListener(eventName, this.scheduleViewportUpdate));
        };

        addListener(window, 'resize');
        addListener(window, 'orientationchange');
        addListener(window.visualViewport, 'resize');
        addListener(window.visualViewport, 'scroll');
    }

    private scheduleViewportUpdate = () => {
        if (this.viewportRaf) cancelAnimationFrame(this.viewportRaf);
        this.viewportRaf = requestAnimationFrame(() => this.updateViewportState());
    }

    private updateViewportState() {
        this.viewportRaf = 0;

        const viewport = window.visualViewport;
        const currentHeight = Math.max(320, Math.round(viewport?.height || window.innerHeight || document.documentElement.clientHeight || 0));
        const currentWidth = Math.round(viewport?.width || window.innerWidth || document.documentElement.clientWidth || 0);
        const viewportWidthChanged = Math.abs(currentWidth - this.baseViewportWidth) > 80;

        if (!this.baseViewportHeight || viewportWidthChanged) {
            this.baseViewportHeight = Math.max(currentHeight, Math.round(window.innerHeight || currentHeight));
            this.baseViewportWidth = currentWidth;
        }

        const wasKeyboardActive = this.keyboardActive;
        const keyboardDelta = this.baseViewportHeight - currentHeight;
        this.keyboardActive = currentWidth > currentHeight && keyboardDelta > this.keyboardThreshold;

        if (!this.keyboardActive && currentHeight > this.baseViewportHeight) {
            this.baseViewportHeight = currentHeight;
        }

        this.viewportHeightStyle = `${currentHeight}px`;
        this.ref.detectChanges();

        if (this.keyboardActive || wasKeyboardActive) {
            this.scrollFocusedControlIntoView();
        }
    }

    private scrollFocusedControlIntoView() {
        window.setTimeout(() => {
            const active = document.activeElement as HTMLElement | null;
            if (!active || !active.matches('input, textarea, select')) return;
            active.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
        }, 80);
    }
}

export default LayoutAuthComponent;